// Placeholder de pantalla dentro de un portal: título real de la sección + aviso de construcción.
// Lo usan las rutas `$section` (y los Home) de los portales mientras se construye el esqueleto.
import { Wrench } from 'lucide-react';

export function UnderConstruction({ title, hint }: { title: string; hint?: string }) {
    return (
        <div className="flex h-full min-h-[60vh] flex-col items-center justify-center rounded-xl border border-dashed border-border text-center">
            <span className="flex size-12 items-center justify-center rounded-xl bg-muted text-muted-foreground">
                <Wrench className="size-6" aria-hidden />
            </span>
            <h1 className="mt-4 text-lg font-bold tracking-tight text-foreground">{title}</h1>
            <p className="mt-1 max-w-sm text-sm text-muted-foreground">
                {hint ?? 'Pantalla en construcción.'}
            </p>
        </div>
    );
}
